export const Uploading = "Uploading ...";
export const UploadingImage = "Uploading Customer's Image, It May Take A While Please Wait !";